import { createContext } from 'react';

export const MainIconBarContext = createContext(null);
